
import { Options, prop, Vue } from "vue-class-component";
import ModalProses from "@/app/ui/components/modal-v2/modal-proses.vue";
import validatePlateNumber from "@/app/infrastructures/misc/common-library/ValidatePlateNumber";
import { parsingErrorResponse } from "@/app/infrastructures/misc/Utils";
import { ErrorMessageEntities, ModalMessageEntities, OptionsClass } from "@/domain/entities/MainApp";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { HubToHubController } from "@/app/ui/controllers/HubToHubController";
import { AddProsesManifest } from "@/data/payload/api/HubToHubApiRequest";
import { getHubData } from "@/app/infrastructures/misc/Cookies";
import { HubController } from '@/app/ui/controllers/HubController';
import SelectSearchV2 from "@/app/ui/components/select-search/index.vue";
import { storeDatatoLocalStorage } from "@/app/infrastructures/misc/Utils"


class Props {
  isOpen = prop<boolean>({
    default: false,
    required: true,
    type: Boolean,
  });
  isStatus = prop<string>({
    default: '',
    type: String,
  });
}

@Options({
  emits: ["update:isOpen"],
  components: {
  ModalProses,
  SelectSearchV2
  },
})
export default class ModalManifest extends Vue.with(Props) {
  mounted() {
    this.getHubList();
  }
  hub = "" as any;
  vehiclePlate = "";
  status = this.isStatus;
  hubId = getHubData()?.hubId || "0";

  onCloseModal() {
    this.$emit("update:isOpen", false);
  }

  controller = HubToHubController;
  goBack() {
    this.$emit("update:isOpen", false);
    MainAppController.closeMessageModal();
    this.clearLocalStorage();
    this.$router.push(this.isStatus === 'IN-HUB' ? '/hub-to-hub/in-hub' : '/hub-to-hub/out-hub');
  }
  clearLocalStorage() {
    this.controller.setScanFailedData([]);
    storeDatatoLocalStorage(this.isStatus === 'OUT-HUB' ? "out-hub-scan-failed" : "in-hub-scan-failed", []);
  }

  async onConfirm() {
    MainAppController.closeMessageModal();
    MainAppController.closeErrorMessage();
    MainAppController.showLoading();
    const basePayload: any = {
      hubId: Number(getHubData()?.hubId) || 0,
      status: this.isStatus,
      plateNumber: this.vehiclePlate,
    };
    if(this.isStatus === "OUT-HUB") basePayload.hub = { ...this.hub };
    try {
      const response = await HubToHubController.processHubManifest(
        new AddProsesManifest(basePayload)
      );
      this.onCloseModal();
      MainAppController.showMessageModal(
        new ModalMessageEntities({
          image: "badge-success", 
          title: `Manifest ${response.data.hub_manifest_code} ${this.$t('hubToHub.berhasil')}!`,
          textSuccess: "Oke",
          onSubmit: this.goBack,
          imageWidth: "32",
          imageHeight: "32"
        })
      );
    } catch (error) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(
          error,
          `Manifest ${this.$t('hubToHub.gagal')}!`,
          this.onConfirm
        )
      );
    } finally {
      MainAppController.closeLoading();
    }
  }

  error = {
    vehiclePlate: false,
  };

  get errorCaption() {
    return {
      vehiclePlate: this.$t("hubToHub.invalidPlate"),
    };
  }

  formatPlateNumber(value: string) {
    return value.toUpperCase().replace(" ", "");
  }
  validateVehicleNumber() {
    this.error.vehiclePlate = validatePlateNumber(this.vehiclePlate);
  }
  getHubList() {
    HubController.getHubListByBaggingGroup();
  }
  get hubList() {
    return HubController.hubListByBaggingGroup.filter(hub => {
      const hubIdExcluded = getHubData()?.hubId !== 0 ? hub.hubId !== getHubData()?.hubId : true;
      return hubIdExcluded
    })
  }
  searchHub = ""
  filterHubLists(search: any) {
    this.searchHub = search
  }

  get filterHubList() {
    return [
      ...this.hubList.map((hub, index) => {
        return {
          hubName: hub.hubType === "hub" ? hub.hubName : `${hub.hubCityCode} - ${hub.hubName}`,
          hubId: hub.hubId,
          hubType: hub.hubType,
          hubCityCode: hub.hubCityCode
        };
      })
    ].filter((hub) => {
      const matchesSearch = this.searchHub
        ? hub.hubName.toLowerCase().includes(this.searchHub.toLowerCase())
        : true;

      return matchesSearch;
    });
  }

  onSelectHub(value: any) {
    if (value) {
      this.hub = {
        hubId: value.hubId,
        hubName: value.hubName,
        hubType: value.hubType,
        hubCityCode: value.hubCityCode
      };
    } else {
      this.hub = "";
    }
  }
}
